import { Component, ViewChild, OnInit, ElementRef, TemplateRef, HostListener, OnDestroy } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

import { Observable, Subscription } from 'rxjs';
import { BeatsService } from 'src/app/services/beats-service/beats.service';
import { BeatListModel } from 'src/app/models/beat-list-model';
import { environment } from 'src/environments/environment';
import { CommonBeatsDialogComponent } from '../popups/common-beat-popups/common-beats-dialog.component';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { FavoriteService } from 'src/app/services/favorite/favorite.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { PlayerService } from 'src/app/services/music-player/player.service';
import { StreamState } from 'src/app/models/stream';
import { LicenseSlug } from 'src/app/models/selected-files-data';
import { ActivatedRoute } from '@angular/router';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { SoundPlayerService } from 'src/app/services/sound-player/sound-player.service';
import { PlayAnalyticsService } from 'src/app/services/analytics/play-analytics.service';
import { MobileVerificationFlowService } from 'src/app/services/Auth/mobile-verification-flow.service';
import { CampaignService } from 'src/app/services/campaign/campaign.service';


@Component({
  selector: 'ipm-music-player',
  templateUrl: './music-player.component.html',
  styleUrls: ['./music-player.component.scss'],
})
export class MusicPlayerComponent implements OnInit, OnDestroy {
  state: StreamState;
  currentIndex: number = 0;
  currentPlayBeat: BeatListModel;
  isOpenMusicPlayer: boolean = false;
  beatList: Array<BeatListModel> = [];
  subscription: Array<Subscription> = [];
  isAudioMute: boolean = false;
  isShowPriceOptions: any =  true;
  isUpdateBeatStatus: boolean = false;
  isShowLoader: boolean = false;
  isAutoPlay: boolean = true;
  isAudioLoop: boolean = false;
  touchStartX: number = 0;
  touchEndX: number = 0;
  touchStartY: number = 0;
  touchEndY: number = 0;
  private swipeThreshold: number = 50;
  private currentAnalyticsSessionId: string | null = null;
  private isCreatingAnalyticsSession: boolean = false;
  private nextAnalyticsCreateRetryAt: number = 0;
  private isEndingAnalyticsSession: boolean = false;
  slideAnimationClass: string = '';
  private pauseDebounceTimer: any = null;
  private analyticsSyncTimer: any = null;
  private firstPlayTime: number | null = null; // Track first play time for guest users
  private firstPlayTimer: any = null; // Timer to check 1-minute threshold
  private lastTrackedAdServeUid: string | null = null; // ensures an ad play fires once per serve, not on every state tick
  isSeeking: boolean = false; // True while the user is dragging the seek bar (prevents timeupdate fighting the thumb)
  seekDisplayTime: number = 0; // The value bound to the slider thumb — only updated by timeupdate when NOT seeking
  /** Phuljhari (sparkler) on the seek head: fixed spread and timing (css animation, no timers) */
  readonly phuljhariSparks: Array<{ angle: number; dist: number; length: number; delay: number; duration: number; color: string; crackle: boolean }> = this.buildPhuljhariSparks();
  readonly phuljhariEmbers: Array<{ dx: number; dy: number; delay: number; duration: number }> = this.buildPhuljhariEmbers();

  @ViewChild('commonSharedCop') sharedDialog : CommonBeatsDialogComponent;
  @ViewChild('loginAlertUserPopup', { static: false }) loginAlertUserPopup: TemplateRef<any>;
  
  constructor(
    private beatService: BeatsService,
    private browserStorageService: BrowserStorageService,
    private favoriteService: FavoriteService,
    public commonService: CommonService,
    public ga4Tracking: Ga4trackingService,
    public musicPlayerService: PlayerService,
    private activatedRoute: ActivatedRoute,
    private soundPlayerService: SoundPlayerService,
    private playAnalyticsService: PlayAnalyticsService,
    private mobileVerificationFlow: MobileVerificationFlowService,
    private campaignService: CampaignService) {}

  onTouchStart(event: TouchEvent): void {
    const target = event.target as HTMLElement;
    if (target.closest('mat-slider, .ipm-music-slider')) {
      return; // Ignore swipes that originate on the seekbar
    }
    if (event.changedTouches.length > 0) {
      this.touchStartX = event.changedTouches[0].screenX;
      this.touchStartY = event.changedTouches[0].screenY;
    }
  }

  onTouchEnd(event: TouchEvent): void {
    const target = event.target as HTMLElement;
    if (target.closest('mat-slider, .ipm-music-slider')) {
      return; // Ignore swipes that originate on the seekbar
    }
    if (event.changedTouches.length > 0) {
      this.touchEndX = event.changedTouches[0].screenX;
      this.touchEndY = event.changedTouches[0].screenY;
      this.handleSwipe();
    }
  }

  private handleSwipe(): void {
    const deltaX = this.touchEndX - this.touchStartX;
    const deltaY = this.touchEndY - this.touchStartY;
    
    // Only register as a swipe if horizontal movement is greater than vertical movement
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      if (deltaX < -this.swipeThreshold) {
        // Swiped left -> next
        this.next();
      } else if (deltaX > this.swipeThreshold) {
        // Swiped right -> previous
        this.previous();
      }
    }
    // Reset to prevent accidental repeated trigger
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.touchStartY = 0;
    this.touchEndY = 0;
  }

  ngOnInit(): void {
    /**
     * In this  subscription update the audio player state
     */
    let subs1: Subscription = this.musicPlayerService.getState().subscribe((state:any) => {
      this.state = state;

      // Only update the slider display value when the user is NOT dragging the seek thumb
      if (!this.isSeeking && state.currentTime !== undefined) {
        this.seekDisplayTime = state.currentTime;
      }

      // Failsafe: auto-clear isSeeking if audio ended or errored
      if (this.isSeeking && (state.ended || state.error)) {
        this.isSeeking = false;
        if (state.currentTime !== undefined) {
          this.seekDisplayTime = state.currentTime;
        }
      }

      this.commonService.setMusicPlaying(!!state.playing);

      if (state.playing) {
        this.clearPauseDebounceTimer();
      }

      // this.startAnalyticsSessionIfReady();
      if (this.currentAnalyticsSessionId && state.currentTime !== undefined) {
        this.playAnalyticsService.updatePlaybackTime(state.currentTime);
      }
      
      const loopValue =  this.musicPlayerService.isAudioPlayerIsLoop();
      if (this.isAudioLoop) {
        this.isLoop();
      }
      if (!loopValue) {
        if (state.ended &&  this.isAutoPlay) {
          // End current session as complete before switching to next beat
          if (this.currentAnalyticsSessionId) {
            this.endAnalyticsSession(true);
          }

          if (this.currentIndex < this.beatList.length - 1) {
            this.currentIndex = this.currentIndex + 1;
          } else {
            this.currentIndex = 0;
          }
          this.beatService.currentPlayBeat.next(this.beatList[this.currentIndex]);
        }
      }
    });

    this.subscription.push(subs1);
    

     /**
     * In this subscription Method we are opening using Player
     */
     this.beatService.isMusicPlayOpen.subscribe( response => {
       this.isOpenMusicPlayer = response;
       if (!response && this.currentAnalyticsSessionId) {
         this.endAnalyticsSession(false);
       }
    });

    /**
     * In this subscription update the playlist items
     */
    let subs2: Subscription = this.beatService.playerBeatsList.subscribe(
      (beats: Array<BeatListModel>) => {
        if (beats.length) {
          this.beatList = beats;
        }
      }
    );
    this.subscription.push(subs2);

    /**
     * In this subscription play beat
     */
    let subs3: Subscription = this.beatService.currentPlayBeat.subscribe(
      (beatObj: BeatListModel) => {
        if (
          this.currentAnalyticsSessionId &&
          this.currentPlayBeat?._id &&
          beatObj?._id &&
          this.currentPlayBeat._id !== beatObj._id
        ) {
          this.endAnalyticsSession(false);
        }

        this.musicPlayerService.stop();
        this.isShowLoader = true;
        if (beatObj && Object.keys(beatObj).length) {
          this.currentPlayBeat = beatObj;
          if (this.currentPlayBeat.hasOwnProperty('isPublic')) {
            this.isShowPriceOptions = this.currentPlayBeat['isPublic'];
          } else {
            this.isShowPriceOptions =  true;
          }
          if (this.beatList.length > 0) {
            this.currentIndex = this.beatList.findIndex(
              (beatObj: BeatListModel) =>
                beatObj._id === this.currentPlayBeat._id
            );
          }
          this.isBeatPlay();
        }
      }
    );
    this.subscription.push(subs3);

    /**
     * Subscribe to analytics events from player service
     */
    // Pause event
    let subs4: Subscription = this.musicPlayerService.onPause().subscribe(() => {
      this.handlePauseForAnalytics();
    });
    this.subscription.push(subs4);
    
    // Seek event
    let subs5: Subscription = this.musicPlayerService.onSeek().subscribe(() => {
      if (this.currentAnalyticsSessionId) {
        this.playAnalyticsService.registerSeek(this.state?.currentTime || 0);
      }
    });
    this.subscription.push(subs5);
    
    // Ended event
    let subs6: Subscription = this.musicPlayerService.onEnded().subscribe(() => {
      if (this.currentAnalyticsSessionId) {
        // Check if loop is enabled - if so, increment replay count instead of ending session
        const isLoopEnabled = this.musicPlayerService.isAudioPlayerIsLoop();
        if (isLoopEnabled) {
          this.playAnalyticsService.incrementReplayCount();
        } else {
          this.endAnalyticsSession(true);
        }
      }
    });
    this.subscription.push(subs6);

    let subs7: Subscription =
      this.playAnalyticsService.mobileVerificationBlocked$.subscribe(() => {
        this.handlePlaybackBlockedByVerificationWall();
      });
    this.subscription.push(subs7);
  }

  /**
   * In this function check is Hlc supported or not
   */
  isBeatPlay() {
    let data  =  this.browserStorageService.getSessionData();
      if (!data) {
        let playCount:any =  this.browserStorageService.getPlayCount();
        if (!playCount) {
          this.browserStorageService.setPlayCountNonLoginUser(1);
        } else {
          playCount =  +playCount;
          if (playCount < 10) {
            playCount =  +playCount;
            playCount += 1;
            this.browserStorageService.setPlayCountNonLoginUser(playCount);
            this.checkHLSupport(this.currentPlayBeat,this.currentIndex);
          } else if (playCount >= 10 && !this.browserStorageService.hasSeenListeningDashboardPromo()) {
            this.browserStorageService.setListeningDashboardPromoSeen();
            this.isShowLoader = false;
            // this.openAuthAlertModel("limitExceed");
          }
        }
        this.checkHLSupport(this.currentPlayBeat, this.currentIndex);
        this.startFirstPlayTimer();
      } else {
        this.checkHLSupport(this.currentPlayBeat,this.currentIndex);
        this.startFirstPlayTimer();
      }
  }

  /**
   * Update the status in current beat
   * @param url
   */
  playStream(url:any) {
    let subs: Subscription = this.musicPlayerService.playStream(url)
    .subscribe(events => {
      if (this.isUpdateBeatStatus) {
        this.isUpdateBeatStatus = false;
        this.musicPlayerService.getState().subscribe((state:any) => {
          if (state.playing) {
            this.currentPlayBeat.isPlayMusic = true;
            this.isShowLoader = false;
            const adBeat: any = this.currentPlayBeat;
            if (adBeat?.is_ad && adBeat.serve_uid && adBeat.serve_uid !== this.lastTrackedAdServeUid) {
              // getState() emits on every playback tick; without this guard the play
              // event spams continuously. Fire once per served ad (serve_uid).
              this.lastTrackedAdServeUid = adBeat.serve_uid;
              this.campaignService.trackPlay(adBeat).subscribe();
            }
          } else {
            this.currentPlayBeat.isPlayMusic = false;
          }
          this.beatService.isUpdateData.next(this.currentPlayBeat);
        });
      }
    });
  }

  /**
   * in this function checking htl supports or not according to
   * it's call then function
   * @param file
   * @param index
   * @returns
   */
  checkHLSupport(file:any, index:any) {
    if (new Audio().canPlayType('application/vnd.apple.mpegurl')) {
      this.openFile(file, index);
      return;
    }
    this.beatService.getPreviewFileUrl(file._id).subscribe( resMUsic => {
      if (resMUsic?.url) {
        this.musicPlayerService.stop();
        this.musicPlayerService.audioObj.currentTime = 0;
        this.musicPlayerService.resetState()
        this.isUpdateBeatStatus = true;
        this.playStream(resMUsic?.url);
        // this.startAnalyticsSessionIfReady();
        this.countBeatApi();
      }
    }, error => {
      this.commonService.showToastErrorMessage(`could not fetch beat url,${file._id}`);
    })
  }

  /**
   * get Url and create chunks
   * @param file
   * @param index
   */
  openFile(file:any, index:any) {
    let  str_len : string = file.preview;
    let  getBeatId = str_len.split(".com")[1].replace("preview.mp3","");
    let beat_full_id =  getBeatId.slice(1,getBeatId.length-1);
    let beatUrl = '';
    let  sub1 =  this.beatService.getBeatStreamUrl(beat_full_id).subscribe( res => {
      if (res &&  res.length) {
        let ticket = res.split("?")[1];
        beatUrl = environment.beatPlayUrl+beat_full_id+"&"+ticket;
        this.musicPlayerService.stop();
        this.isUpdateBeatStatus = true;
        this.playStream(beatUrl);
        // this.startAnalyticsSessionIfReady();
        this.countBeatApi();
      } else  {
        this.commonService.showToastErrorMessage('could not fetch beat url');
        return;
      }
    });
  }

  /**
   * pause music PLay Function
   */
  pause() {
    this.musicPlayerService.pause();
    let event = 'music_player_pause_beats';
    let attributes: any = {
      category: 'Beats',
      label: 'Engagement',
      userRole : this.browserStorageService?.getCurrentRoles() || 'guest',
      userId : this.browserStorageService?.getUserId() || 'guest',
      action: 'pause',
      Genre: this.currentPlayBeat?.genre || 'N/A',

      Tempo : this.currentPlayBeat?.tempo || 'N/A'
    }
    if (Array.isArray(this.currentPlayBeat?.mood)) {
      this.currentPlayBeat.mood.forEach((mood: string, index: number) => {
        attributes[`mood${index + 1}`] = mood;
      });
    }
    this.ga4Tracking.sendEvent(event, attributes);
  }

  play() {
    this.musicPlayerService.play();
    let event = 'music_player_play_beats';
    let attributes: any = {
      category: 'Beats',
      label: 'Engagement',
      userRole : this.browserStorageService?.getCurrentRoles() || 'guest',
      userId : this.browserStorageService?.getUserId() || 'guest',
      action: 'play',
      Genre: this.currentPlayBeat?.genre || 'N/A',
      Tempo : this.currentPlayBeat?.tempo || 'N/A',
    }
    if (Array.isArray(this.currentPlayBeat?.mood)) {
      this.currentPlayBeat.mood.forEach((mood: string, index: number) => {
        attributes[`mood${index + 1}`] = mood;
      });
    }
    this.ga4Tracking.sendEvent(event
      , attributes);
  }

  stop() {
    this.musicPlayerService.stop();
    let event = 'music_player_stop_beats';
    let attributes: any = {
      category: 'Beats',
      label: 'Engagement',
      userRole : this.browserStorageService?.getCurrentRoles() || 'guest',
      userId : this.browserStorageService?.getUserId() || 'guest',
      action: 'stop',
      Genre: this.currentPlayBeat?.genre || 'N/A',

      Tempo : this.currentPlayBeat?.tempo || 'N/A'
    }
    if (Array.isArray(this.currentPlayBeat?.mood)) {
      this.currentPlayBeat.mood.forEach((mood: string, index: number) => {
        attributes[`mood${index + 1}`] = mood;
      });
    }
    this.ga4Tracking.sendEvent(event, attributes);
  }

  next() {
    let data  =  this.browserStorageService.getSessionData();
    if (!data) {
      let playCount:any =  this.browserStorageService.getPlayCount();
      if (playCount >= 10 && !this.browserStorageService.hasSeenListeningDashboardPromo()) {
        // this.openAuthAlertModel("limitExceed");
      } else {
        this.netPlayFunc();
      }
    } else {
      this.netPlayFunc();
    }
  }

  netPlayFunc() {
    this.slideAnimationClass = 'slide-left-anim';
    setTimeout(() => this.slideAnimationClass = '', 350);

    if (this.currentAnalyticsSessionId) {
      this.endAnalyticsSession(false);
    }
    
    let INDEX: number = this.currentIndex
      if (this.currentIndex < this.beatList.length - 1) {
        INDEX = this.currentIndex + 1;
      } else {
        INDEX = 0;
      }
      this.handleForWordPlay(INDEX);
      let event = 'music_player_next_beats';
      let attributes: any = {
        category: 'Beats',
        label: 'Engagement',
        userRole : this.browserStorageService?.getCurrentRoles() || 'guest',
        userId : this.browserStorageService?.getUserId() || 'guest',
        action: 'next',
        Genre: this.currentPlayBeat?.genre || 'N/A',
      Tempo : this.currentPlayBeat?.tempo || 'N/A'
      }
      if (Array.isArray(this.currentPlayBeat?.mood)) {
        this.currentPlayBeat.mood.forEach((mood: string, index: number) => {
          attributes[`mood${index + 1}`] = mood;
        });
      }
      this.ga4Tracking.sendEvent(event, attributes);
  }

  previous() {
    let data  =  this.browserStorageService.getSessionData();
    if (!data) {
      let playCount:any =  this.browserStorageService.getPlayCount();
      if (playCount >= 10 && !this.browserStorageService.hasSeenListeningDashboardPromo() ) {
        // this.openAuthAlertModel("limitExceed");
      } else {
        this.previousPlayFunction();
      }
    } else {
      this.previousPlayFunction();
    }
  }

  previousPlayFunction() {
    this.slideAnimationClass = 'slide-right-anim';
    setTimeout(() => this.slideAnimationClass = '', 350);

    // End current analytics session before switching
    if (this.currentAnalyticsSessionId) {
      this.endAnalyticsSession(false);
    }
    
    let INDEX: number = this.currentIndex
    if (this.currentIndex > 0) {
      INDEX = this.currentIndex - 1;
    } else {
      INDEX = this.beatList.length - 1;
    }
    this.handleForWordPlay(INDEX);
    let event = 'music_player_previous_beats';
    let attributes: any = {
      category: 'Beats',
      label: 'Engagement',
      userRole : this.browserStorageService?.getCurrentRoles() || 'guest',
      userId : this.browserStorageService?.getUserId() || 'guest',
      action: 'previous',
      Genre: this.currentPlayBeat?.genre || 'N/A',
      Tempo : this.currentPlayBeat?.tempo || 'N/A'
    }
    if (Array.isArray(this.currentPlayBeat?.mood)) {
      this.currentPlayBeat.mood.forEach((mood: string, index: number) => {
        attributes[`mood${index + 1}`] = mood;
      });
    }
    this.ga4Tracking.sendEvent(event, attributes);
  }

  handleForWordPlay(index: number) {
    if (this.beatList[index].hasOwnProperty('prices')) {
      this.beatService.currentPlayBeat.next(this.beatList[index]);
    } else {
      this.getCurrentBeatData(this.beatList[index])
    }
  }

  isFirstPlaying() {
    return this.currentIndex === 0;
  }

  isLastPlaying() {
    return this.currentIndex === this.beatList.length - 1;
  }

  /**
   * Update the value of time seek bar
   * when the slider ends
   * @param change
   */
  onSliderChangeEnd(change:any) {
    this.isSeeking = false;
    const seekValue = change.value ?? this.seekDisplayTime;
    this.musicPlayerService.seekTo(seekValue);
    
    // Track seek for analytics
    if (this.currentAnalyticsSessionId) {
      this.playAnalyticsService.registerSeek(seekValue);
    }
    
    let event = 'seek_bar_beats';
    let attributes: any = {
      category: 'Beats',
      label: 'Engagement',
      action: 'seek',
      Genre: this.currentPlayBeat?.genre || 'N/A',
      Tempo : this.currentPlayBeat?.tempo || 'N/A',
      userRole : this.browserStorageService?.getCurrentRoles() || 'guest',
      userId : this.browserStorageService?.getUserId() || 'guest',
    }
    if (Array.isArray(this.currentPlayBeat?.mood)) {
      this.currentPlayBeat.mood.forEach((mood: string, index: number) => {
        attributes[`mood${index + 1}`] = mood;
      });
    }
    this.ga4Tracking.sendEvent(event , attributes);
  }

  /**
   * Fallback for iOS where dragEnd may not fire.
   * The native (change) event fires reliably on touch-end.
   */
  onSliderChange(event: any) {
    this.isSeeking = false;
    const value = event?.target?.value ?? this.seekDisplayTime;
    if (value !== undefined && value !== null) {
      this.musicPlayerService.seekTo(+value);
    }
  }

  /**
   * Fires while the user drags the seek thumb (before release).
   * On iOS this keeps the slider visually responsive to the user's finger.
   */
  onSliderInput(event: any) {
    this.isSeeking = true;
    const value = event?.target?.value;
    if (value !== undefined && value !== null) {
      this.seekDisplayTime = +value;
    }
  }

  /**
   * Called when a touch begins on the seek bar.
   * Sets isSeeking so timeupdate events don't fight the thumb position,
   * and stops propagation so the swipe-to-change-song gesture isn't triggered.
   */
  onSeekTouchStart(event: TouchEvent): void {
    this.isSeeking = true;
    event.stopPropagation(); // Don't trigger parent swipe gesture
  }

  /**
   * Called when the touch ends on the seek bar.
   * The actual seek is applied via onSliderChange / onSliderChangeEnd.
   * Stop propagation to prevent swipe gesture.
   */
  onSeekTouchEnd(event: TouchEvent): void {
    event.stopPropagation(); // Don't trigger parent swipe gesture
    // isSeeking is cleared in onSliderChange/onSliderChangeEnd which fires after this
  }

  /**
   * Play or Pause function
   * @param isPlay
   */
  songPlay(isPlay:any) {
    this.soundPlayerService.pause();
    if (isPlay) {
      this.pause();
      this.currentPlayBeat.isPlayMusic = false;
    } else {
      this.play();
      this.currentPlayBeat.isPlayMusic = true;
    }
  }

  /**
   * In this function update the value of
   * volume slider bar
   * @param event
   */
  onVolumeChange(value: any) {
    this.musicPlayerService.volumeChange(value);
    if (value == 0) {
      this.isAudioMute = true;
      this.isMute();
    } else {
      this.isAudioMute = false;
       this.isMute();
    }
  }

  /**
   * mute the music player volume
   */
  isMute() {
    this.musicPlayerService.volumeMute(this.isAudioMute);
  }

  /**
   * Playing in music loop Function
   */
  isLoop() {
    this.musicPlayerService.loop(this.isAudioLoop);
  }

  /**
   * On click Mute Button set
   * the volume is mute
   */
  volumeMute(){
    const muteValue =  this.musicPlayerService.isAudioPlayerIsMute();
    this.isAudioMute = muteValue ? false : true;
    this.isMute();
  }

  isMusicLoop() {
    const loopValue =  this.musicPlayerService.isAudioPlayerIsLoop();
    this.isAudioLoop = loopValue ? false : true;
    this.isLoop();
  }

  ngOnDestroy(): void {
    this.clearPauseDebounceTimer();
    this.stopPeriodicAnalyticsSync();

    if (this.currentAnalyticsSessionId) {
      this.endAnalyticsSession(false);
    }
    
    this.subscription.map(item => {
      item.unsubscribe();
    });
  }

  private handlePauseForAnalytics(): void {
    if (
      !this.currentAnalyticsSessionId ||
      this.isEndingAnalyticsSession ||
      this.state?.ended
    ) {
      return;
    }

    this.clearPauseDebounceTimer();
    this.pauseDebounceTimer = setTimeout(() => {
      if (this.currentAnalyticsSessionId) {
        if ((this.state?.currentTime || 0) <= 0) {
          return;
        }
        this.playAnalyticsService.incrementPauseCount();
        this.playAnalyticsService.sendAnalyticsUpdate().subscribe();
      }
    }, 500);
  }

  private endAnalyticsSession(isComplete: boolean): void {
    if (!this.currentAnalyticsSessionId || this.isEndingAnalyticsSession) return;
    this.isEndingAnalyticsSession = true;

    this.clearPauseDebounceTimer();
    this.stopPeriodicAnalyticsSync();

    this.playAnalyticsService.endPlaybackSession(isComplete).subscribe({
      complete: () => {
        this.isEndingAnalyticsSession = false;
      },
      error: () => {
        this.isEndingAnalyticsSession = false;
      }
    });
    this.currentAnalyticsSessionId = null;
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler(): void {
    const sessionId = this.playAnalyticsService.getCurrentSessionId();
    if (!sessionId) return;

    const payload = this.playAnalyticsService.getCurrentSessionUpdatePayload(false);
    if (!payload) return;

    fetch(`${environment.apiBaseUrl}beat/playAnalytics/${sessionId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    });
  }

  private startAnalyticsSessionIfReady(): void {
    const now = Date.now();
    const duration = this.state?.duration || 0;

    if (
      this.currentAnalyticsSessionId ||
      this.isCreatingAnalyticsSession ||
      now < this.nextAnalyticsCreateRetryAt ||
      !this.currentPlayBeat?._id
    ) {
      return;
    }

    this.isCreatingAnalyticsSession = true;
    this.playAnalyticsService.startPlaybackSession(
      this.currentPlayBeat._id,
      duration
    ).subscribe((sessionId) => {
      this.isCreatingAnalyticsSession = false;
      if (!sessionId) {
        this.nextAnalyticsCreateRetryAt = Date.now() + 10000;
        return;
      }
      this.nextAnalyticsCreateRetryAt = 0;
      this.currentAnalyticsSessionId = sessionId;
      // this.startPeriodicAnalyticsSync();
    }, () => {
      this.isCreatingAnalyticsSession = false;
      this.nextAnalyticsCreateRetryAt = Date.now() + 10000;
    });
  }

  private clearPauseDebounceTimer(): void {
    if (this.pauseDebounceTimer) {
      clearTimeout(this.pauseDebounceTimer);
      this.pauseDebounceTimer = null;
    }
  }

  private startPeriodicAnalyticsSync(): void {
    this.stopPeriodicAnalyticsSync();
    this.analyticsSyncTimer = setInterval(() => {
      if (this.currentAnalyticsSessionId) {
        this.playAnalyticsService.sendAnalyticsUpdate().subscribe();
      }
    }, 30000);
  }

  private stopPeriodicAnalyticsSync(): void {
    if (this.analyticsSyncTimer) {
      clearInterval(this.analyticsSyncTimer);
      this.analyticsSyncTimer = null;
    }
  }

  openBeatDownloadDialogBox() {
    if (this.browserStorageService.getSessionData()) {
      this.sharedDialog.openCommonDownloadModel(this.currentPlayBeat);
      let currentevent = 'dialog_free_mp3_download';
      let attributes: any = {
        category: 'Beats',
        label: 'download',
        action: 'click',
        Genre: this.currentPlayBeat?.genre || 'N/A',
        userRole : this.browserStorageService?.getCurrentRoles() || 'guest',
        userId : this.browserStorageService?.getUserId() || 'guest',
       }
      this.ga4Tracking.sendEvent(currentevent, attributes);
    } else {
      this.openAuthAlertModel();
    }
  }

  openBeatShareDialogBox() {
    this.sharedDialog.openShareDialog('bt-'+this.currentPlayBeat.serial_number, 'beat');
  }

  get isUserLoggedIn(): boolean {
    return !!this.browserStorageService.getSessionData();
  }

  openLyricsEditor() {
    if (this.isUserLoggedIn) {
      const userRole = this.browserStorageService?.getCurrentRoles() || 'guest';
      const userId = this.browserStorageService?.getUserId() || 'guest';
      this.ga4Tracking.sendEvent('click_lyrics', {
        category: 'Beats',
        label: 'Engagement',
        action: 'click',
        userRole,
        userId,
      });
      this.sharedDialog.openLyricsEditor(this.currentPlayBeat);
    } else {
      this.openAuthAlertModel();
    }
  }

  openPricePopup() {
    let selectedSlugLic: any = "";
    if (this.activatedRoute.snapshot.queryParams['beats_with_exclusives']) {
      selectedSlugLic = LicenseSlug.Exclusive;
    } else if (this.activatedRoute.snapshot.queryParams['wav_stems_1999']) {
      selectedSlugLic = LicenseSlug.WavStem;
    } else if (this.activatedRoute.snapshot.queryParams['wav_under_999']) {
      selectedSlugLic = LicenseSlug.Wav;
    }
    this.sharedDialog.openPriceDialog(this.currentPlayBeat, selectedSlugLic);
  }

  /**
   *  In this function add and
   * remove beat from the list
   * @param beatObj
   */
  addORemoveBeatIntoFavList() {
    let data: any =  this.browserStorageService.getSessionData();
    if (data) {
      let isFav: boolean = this.currentPlayBeat.isFav ?  this.currentPlayBeat.isFav : false ;
      isFav = !isFav;
      let beat_id =  this.currentPlayBeat._id;
      let callingType = isFav ? 'favourite' : 'removeFavourite';
      let event = 'liked_beats';
      let attributes: any = {
        category: 'Beats',
        label: 'Engagement',
        action: 'click',
        Genre: this.currentPlayBeat?.genre || 'N/A',
        userRole : this.browserStorageService?.getCurrentRoles() || 'guest',
        userId : this.browserStorageService?.getUserId() || 'guest',


      }
      this.ga4Tracking.sendEvent(event, attributes);
      this.favoriteService.addRemoveFavorite(beat_id, callingType).subscribe((res) => {
          this.currentPlayBeat.isFav = isFav;
          this.beatService.isUpdateData.next(this.currentPlayBeat);
          this.beatService.isUpdateBeatFollowCount.next(this.currentPlayBeat);
          if (this.currentPlayBeat?.is_ad && this.currentPlayBeat.isFav ) {
            this.campaignService.trackClick(this.currentPlayBeat).subscribe();
            this.campaignService.trackFavClick(this.currentPlayBeat).subscribe();
          }
        },(error) => {
          this.commonService.showToastError(error);
        }
      );
    } else {
      this.openAuthAlertModel();
    }
  }

  openAuthAlertModel(type: string = "") {
    this.commonService.closePopUp();
    let className = this.commonService.isMobileDisableClick ? 'ipm-mobile-non-login-alert-shared-model' : 'ipm-non-login-alert-shared-model';
    this.commonService.openModel(this.loginAlertUserPopup, {type: type}, className, false);
    let eventname = 'signup_singin_pop_up';
    let attributes: any = {
      category: 'Beats',
      label: 'Sig up/Sign In',
      action: 'click',
      userRole : this.browserStorageService?.getCurrentRoles() || 'guest',
      userId : this.browserStorageService?.getUserId() || 'guest',


    }
    this.ga4Tracking.sendEvent(eventname, attributes);
  }

  showLoginAlert(isShowAlert: boolean) {
    if (isShowAlert) {
      this.openAuthAlertModel();
    }
  }

  handleRouting(routingName: any, actionType: string) {
    this.commonService.isShowMusicConfirmationPopup.next(routingName)
    if (this.currentPlayBeat?.is_ad) {
      this.campaignService.trackClick(this.currentPlayBeat).subscribe();
      if (actionType === 'producerProfile') {
       this.campaignService.trackProducerProfileClick(this.currentPlayBeat, this.currentPlayBeat?.created_by?._id).subscribe();
      }
    }
  }

  getCurrentBeatData(beat: any) {
    let filterData = {
      filter : {
        beat_id: beat._id
      },
      page: {
        offset: 0,
        limit: 20,
      }
    }
    this.beatService.getBeatList(filterData).subscribe((beatData: Array<BeatListModel>) => {
      let currentBeatDetails: BeatListModel = beatData[0];
      this.beatService.currentPlayBeat.next(currentBeatDetails);
    }, (error: any) => {
      this.commonService.showToastError(error);
    })
  }

  handlePlayPause(currentPLayBeat: any) {
    this.commonService.updatePlayPauseStatus.next(currentPLayBeat);
  }

  private handlePlaybackBlockedByVerificationWall(): void {
    this.musicPlayerService.stop();
    this.isShowLoader = false;
    if (!this.currentPlayBeat) {
      return;
    }

    this.currentPlayBeat.isPlayMusic = false;
    this.currentPlayBeat.isBeatPlayed = false;
    this.beatService.isUpdateData.next(this.currentPlayBeat);
  }

    /**
   * in this function call beat play count api
   */
  countBeatApi() {
    const beatId = this.currentPlayBeat?._id;
    if (!beatId) {
      return;
    }

    this.beatService.countBeatPlay(beatId).subscribe({
      error: (error: any) => {
        if (this.mobileVerificationFlow.triggerFromError(error, 'play', false)) {
          this.handlePlaybackBlockedByVerificationWall();
          return;
        }

        console.error('[MusicPlayer] playCount request failed:', error);
      }
    });
  }
  /**
    * Start timer to check if 1 minute has passed since first beat play for guest users
    */
   private startFirstPlayTimer() {
    // this.browserStorageService.resetListeningDashboardPromoSeen();
    if(this.browserStorageService.hasSeenListeningDashboardPromo()) return ;
     // If we haven't tracked the first play time yet, set it now
     if (this.firstPlayTime === null) {
       // Only track for guest users (no session data)
       if (!this.browserStorageService.getSessionData()) {
         this.firstPlayTime = Date.now();
         // Start checking every second if 1 minute has passed
         this.firstPlayTimer = setInterval(() => {
           if (this.firstPlayTime !== null && !this.browserStorageService.getSessionData() && !this.browserStorageService.hasSeenListeningDashboardPromo()) {
             const timeElapsed = Date.now() - this.firstPlayTime;
             if (timeElapsed >= 60000) { // 1 minute in milliseconds
               this.browserStorageService.setListeningDashboardPromoSeen();
               this.openAuthAlertModel('limitExceed')
               clearInterval(this.firstPlayTimer);
               this.firstPlayTimer = null;
             }
           }
         }, 1000); // Check every second
       }
     }
   }

  /** Seek head position for the phuljhari, as % of the track */
  get phuljhariLeft(): number {
    const duration = this.state?.duration || 0;
    return duration ? Math.min(100, Math.max(0, (this.seekDisplayTime / duration) * 100)) : 0;
  }

  private buildPhuljhariSparks() {
    const colors = ['#FFFFFF', '#FEF3C7', '#FDE68A', '#FBBF24', '#F59E0B', '#F97316'];
    // deterministic spread: golden-angle steps cover every direction; mixed short/long sparks, every 3rd ends in a crackle
    return Array.from({ length: 28 }, (_, i) => ({
      angle: Math.round((i * 137.5) % 360),
      dist: 12 + ((i * 11) % 24),
      length: 5 + ((i * 5) % 9),
      delay: Math.round(((i * 0.053) % 0.7) * 100) / 100,
      duration: 0.4 + ((i * 7) % 6) / 10,
      color: colors[i % colors.length],
      crackle: i % 3 === 0,
    }));
  }

  private buildPhuljhariEmbers() {
    // glowing bits that pop out sideways and fall
    return Array.from({ length: 8 }, (_, i) => ({
      dx: (i % 2 === 0 ? 1 : -1) * (6 + ((i * 5) % 14)),
      dy: 16 + ((i * 7) % 14),
      delay: Math.round(((i * 0.19) % 1.2) * 100) / 100,
      duration: 0.9 + ((i * 3) % 5) / 10,
    }));
  }
}
